module.exports = __webpack_public_path__ + "img/step2-c.501eea5d.png";